export default {
    "indexer": {
        "emitted_for_receipt_id": "6kgfkxZFB94MEHfcjSwjkEw7xYM6j3MAreYZDhLjyRvL",
        "emitted_by_contract_account_id": "24g.contract.bra.testnet",
        "token_id": "Bra-Xbdhoh9nUqgq8hfj4HKIIE",
        "token_old_owner_account_id": "",
        "token_new_owner_account_id": "shizuka_pendulous-breasts_marikawa.training3.bra.testnet",
        "token_authorized_account_id": "",
        "event_memo": ""
    },
    "creator": "Shizuka (Pendulous Breasts) Marikawa",
    "premint_id": "Xbdhoh9nUqgq8hfj4HKIIE",
    "description": "This has been one of my favorite bras, and while I hate to get rid of it, it desperately needs to be replaced.  Sadly, I haven’t been able to find it being sold anywhere now, so I guess it’s even more rare in that sense!  Lol.  I love this bra so much because the underwire is strong and has never poked through, and the material is thick enough to hide my nipples (which I often have a problem with).  As well of course, it’s extremely hard finding bras in my size. ",
    "bra": {
        "brand": "Parfait",
        "name": "Charlotte",
        "color": "{\"name\":\"blue\",\"color\":\"#2196F3\"}",
        "size": {
            "band": 28,
            "cup": "m"
        }
    },
    "photos": [
        {
            "filename": "Xbdhoh9nUqgq8hfj4HKIIE_bra-IMG_20211104_105414.jpg",
            "url": "https://boudoir.branfts.com/Xbdhoh9nUqgq8hfj4HKIIE/Xbdhoh9nUqgq8hfj4HKIIE_bra-IMG_20211104_105414.jpg",
            "_id": "6234183bdb17b3be01e84138"
        },
        {
            "filename": "Xbdhoh9nUqgq8hfj4HKIIE_tag-nft-asset-001-tag.webp",
            "url": "https://boudoir.branfts.com/Xbdhoh9nUqgq8hfj4HKIIE/Xbdhoh9nUqgq8hfj4HKIIE_tag-nft-asset-001-tag.webp",
            "_id": "6234183bdb17b3be01e84139"
        },
        {
            "filename": "Xbdhoh9nUqgq8hfj4HKIIE_left-nft-asset-003-left.webp",
            "url": "https://boudoir.branfts.com/Xbdhoh9nUqgq8hfj4HKIIE/Xbdhoh9nUqgq8hfj4HKIIE_left-nft-asset-003-left.webp",
            "_id": "6234183bdb17b3be01e8413a"
        },
        {
            "filename": "Xbdhoh9nUqgq8hfj4HKIIE_front-nft-asset-005-front.webp",
            "url": "https://boudoir.branfts.com/Xbdhoh9nUqgq8hfj4HKIIE/Xbdhoh9nUqgq8hfj4HKIIE_front-nft-asset-005-front.webp",
            "_id": "6234183bdb17b3be01e8413b"
        },
        {
            "filename": "Xbdhoh9nUqgq8hfj4HKIIE_right-nft-asset-007-right.webp",
            "url": "https://boudoir.branfts.com/Xbdhoh9nUqgq8hfj4HKIIE/Xbdhoh9nUqgq8hfj4HKIIE_right-nft-asset-007-right.webp",
            "_id": "6234183bdb17b3be01e8413c"
        },
        {
            "filename": "Xbdhoh9nUqgq8hfj4HKIIE_back-nft-asset-009-back.webp",
            "url": "https://boudoir.branfts.com/Xbdhoh9nUqgq8hfj4HKIIE/Xbdhoh9nUqgq8hfj4HKIIE_back-nft-asset-009-back.webp",
            "_id": "6234183bdb17b3be01e8413d"
        },
        {
            "filename": "Xbdhoh9nUqgq8hfj4HKIIE_nude-nft-asset-011-back-nude.webp",
            "url": "https://boudoir.branfts.com/Xbdhoh9nUqgq8hfj4HKIIE/Xbdhoh9nUqgq8hfj4HKIIE_nude-nft-asset-011-back-nude.webp",
            "_id": "6234183bdb17b3be01e8413e"
        }
    ],
    "videos": [
        {
            "filename": "Xbdhoh9nUqgq8hfj4HKIIE_fitting-ca8e9901b9c7ab9eb356e294e199ab83",
            "url": "https://boudoir.branfts.com/Xbdhoh9nUqgq8hfj4HKIIE/Xbdhoh9nUqgq8hfj4HKIIE_fitting-ca8e9901b9c7ab9eb356e294e199ab83",
            "_id": "6234183bdb17b3be01e8413f"
        }
    ],
    "secrets": [
        {
            "filename": "Xbdhoh9nUqgq8hfj4HKIIE_secret-33ee4deee572fc3e22a8c52299ae5a00.chest",
            "url": "https://boudoir.branfts.com/Xbdhoh9nUqgq8hfj4HKIIE/Xbdhoh9nUqgq8hfj4HKIIE_secret-33ee4deee572fc3e22a8c52299ae5a00.chest",
            "_id": "6234183bdb17b3be01e84140"
        }
    ],
    "cid": "bafybeic5tv3y4ts54g2jiq4umhchgybypxkcjnmnefhjbfj5igxikxwoxm",
    "screenshots": [
        {
            "filename": "screenshot-1.webp",
            "url": "https://boudoir.branfts.com/Xbdhoh9nUqgq8hfj4HKIIE/screenshot-1.webp",
            "_id": "6234192bdb17b3be01e84146"
        }
    ],
    "log": {
        "date": 1647581354935,
        "name": "callMintContract",
        "complete": 1647581461584
    },
    "token_id": "Bra-Xbdhoh9nUqgq8hfj4HKIIE",
    "blockchainData": {
        "token_id": "Bra-Xbdhoh9nUqgq8hfj4HKIIE",
        "owner_id": "shizuka_pendulous-breasts_marikawa.training3.bra.testnet",
        "metadata": {
            "creator": "shizuka_pendulous-breasts_marikawa.training3.bra.testnet",
            "sn": "000000021",
            "charity": null,
            "provenance": null,
            "sale_conditions": {
                "sale_price": "69000000000000000000000000",
                "buyer_id": null
            },
            "title": "Parfait Charlotte 28M 🟦",
            "description": "Shizuka (Pendulous Breasts) Marikawa",
            "media": "https://github.branfts.com/Bra-Xbdhoh9nUqgq8hfj4HKIIE.webm",
            "media_hash": "tkxIIfOVf2HJ1GcOF7shPqsAZMBuNiMGcnzhtsAPjik=",
            "reference": "https://github.branfts.com/Bra-Xbdhoh9nUqgq8hfj4HKIIE.json",
            "reference_hash": "TAEtG4qFEV0d+lHuzVZC2SK+CMFoCnZSWF7vJqjWhbk="
        },
        "approved_account_ids": {
            "24g.contract.bra.testnet": 0
        },
        "royalty": {
            "susan-g-komen.charity.bra.testnet": 100,
            "24g.contract.bra.testnet": 750,
            "shizuka_pendulous-breasts_marikawa.training3.bra.testnet": 150
        }
    },
    "assets": [
        {
            "type": "image/*",
            "url": "https://boudoir.branfts.com/Xbdhoh9nUqgq8hfj4HKIIE/Xbdhoh9nUqgq8hfj4HKIIE_bra-IMG_20211104_105414.jpg",
            "field": "bra"
        },
        {
            "type": "image/*",
            "url": "https://boudoir.branfts.com/Xbdhoh9nUqgq8hfj4HKIIE/Xbdhoh9nUqgq8hfj4HKIIE_tag-nft-asset-001-tag.webp",
            "field": "tag"
        },
        {
            "type": "image/*",
            "url": "https://boudoir.branfts.com/Xbdhoh9nUqgq8hfj4HKIIE/Xbdhoh9nUqgq8hfj4HKIIE_left-nft-asset-003-left.webp",
            "field": "left"
        },
        {
            "type": "image/*",
            "url": "https://boudoir.branfts.com/Xbdhoh9nUqgq8hfj4HKIIE/Xbdhoh9nUqgq8hfj4HKIIE_front-nft-asset-005-front.webp",
            "field": "front"
        },
        {
            "type": "image/*",
            "url": "https://boudoir.branfts.com/Xbdhoh9nUqgq8hfj4HKIIE/Xbdhoh9nUqgq8hfj4HKIIE_right-nft-asset-007-right.webp",
            "field": "right"
        },
        {
            "type": "image/*",
            "url": "https://boudoir.branfts.com/Xbdhoh9nUqgq8hfj4HKIIE/Xbdhoh9nUqgq8hfj4HKIIE_back-nft-asset-009-back.webp",
            "field": "back"
        },
        {
            "type": "image/*",
            "url": "https://boudoir.branfts.com/Xbdhoh9nUqgq8hfj4HKIIE/Xbdhoh9nUqgq8hfj4HKIIE_nude-nft-asset-011-back-nude.webp",
            "field": "nude"
        }
    ]
}